import React, { Component } from 'react';
import close from "../images/icons/close.png"
import locfinder from "../images/icons/locationFinder.png"
import $ from "jquery";
import { getData } from '../services';

// const isTheme = localStorage.getItem('themeId');
// const theme = (isTheme !== null && isTheme !== "null" && isTheme == "36") ? import('../pothys/pothys.css') : ''
// const themeResponsive = (isTheme !== null && isTheme !== "null" && isTheme == "36") ? import('../pothys/pothys-responsive.css') : ''
export default class location extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cityDetails: [],
      locationDetails: [],
      suggestions: [],
      suggestionsLoc: [],
      textCity: '',
      cityId: '',
      textLocation: '',
      locationId: '',
      topLocations: []

    }
    this.handleCityClick = this.handleCityClick.bind(this)
    this.handleLocationClick = this.handleLocationClick.bind(this)
    this.goClick = this.goClick.bind(this)
    this.checkStoreInLocation = this.checkStoreInLocation.bind(this)
  }
  componentDidMount() {
    let sellerId = window.sessionStorage.getItem('sellerId');
    if (localStorage.getItem('cityText') && localStorage.getItem('locationText')) {
      this.setState({
        textCity: localStorage.getItem('cityText'),
        textLocation: localStorage.getItem('locationText'),
        cityId: localStorage.getItem('cityId'),
        locationId: localStorage.getItem('locationId')
      });
    }

    if (localStorage.getItem('cityText') !== "") {
      var key = ""
      const postData = {
        "functionName": "homepagedata/getCityDetails",
        "sellerId": sellerId,
        "cityKeyWord": key
      }
      getData(postData).then((data) => {
        console.log("dataa", data)
        if (data.data.success === "1") {
          if (data.data.result.cityDetails.length === 1) {
            $("#txtCity").attr('disabled', true)
            this.setState({
              textCity: data.data.result.cityDetails[0].cityName,
              cityId: data.data.result.cityDetails[0].cityId
            });
            if (localStorage.getItem('locationId') === 'null' || localStorage.getItem('locationId') === null || localStorage.getItem('locationId') === '') {
              this.fetchLocationDetails()
            }
          }
          else if (data.data.result.cityDetails.length > 1) {
            $("#locationMainDiv").show()
          }
        }
      })
    }
    if (sellerId !== null && sellerId !== 'null' && sellerId !== '') {
      const postData1 = {
        "functionName": "homepagedata/getTopLocations",
        "sellerId": sellerId
      }
      getData(postData1).then((data) => {
        console.log("data2", data)
        if (data.data.success === "1") {
          this.setState({
            topLocations: data.data.result.locationDetails
          });
        }
      });
    }
  }
  checkStoreInLocation() {

    var storeId = []
    var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
    for (var i = 0; i < selectGroceryItemCart.length; i++) {
      storeId.push(selectGroceryItemCart[i].storeId)
    }
    var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
    for (var j = 0; j < selectCommonItemCart.length; j++) {
      storeId.push(selectCommonItemCart[j].storeId)
    }
    var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
    for (var k = 0; k < selectRestaurantCart.length; k++) {
      storeId.push(selectRestaurantCart[k].storeId)
    }
    if (storeId.length > 0) {
      var storeIdSplit = storeId.toString().replace(/[\[\]']+/g, '')
      
      const postData = {
        "functionName": "lokal/storeLocation",
        "storeId": storeIdSplit,
        "locationId": $("#hidLocationId").val()
      }
      console.log("mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm",postData)
      getData(postData).then((data) => {
        console.log("data3", data)
        if (data.data.success === "1") {
          if (data.data.result.cartClearFlag === "1") {
            var a = window.confirm(data.data.result.message)
            if (a) {
              this.removeCartItems(data.data.result.storeIds);
              this.goClick();
            }
            else {
              $("#txtLocationLokal").val('');
              $(".locationClear").hide();
            }
          }
          else {
            this.goClick();
          }
        }
      })
    }
    else {
      this.goClick();
    }
  }

  removeCartItems(storeIds) {
    var storeIdSpit = storeIds.split(',')
    for (var s = 0; s < storeIdSpit.length; s++) {
      var storeId = storeIdSpit[s]
      var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
      var cookieNewGroceryItemValue = []
      var j = 0
      for (var i = 0; i < selectGroceryItemCart.length; i++) {
        if (storeId != selectGroceryItemCart[i].storeId) {
          cookieNewGroceryItemValue[j] =
          {
            storeId: selectGroceryItemCart[i].storeId.toString().trim(),
            item_names: selectGroceryItemCart[i].item_names.toString().trim(),
            item_ids: selectGroceryItemCart[i].item_ids.toString().trim(),
            quantity: selectGroceryItemCart[i].quantity.toString().trim(),
            item_prices: selectGroceryItemCart[i].item_prices.toString().trim(),
            store_item_stock_ids: selectGroceryItemCart[i].store_item_stock_ids.toString().trim(),
            pack_ids: selectGroceryItemCart[i].pack_ids.toString().trim(),
            stock_quantity: selectGroceryItemCart[i].stock_quantity.toString().trim(),
            item_image: selectGroceryItemCart[i].item_image.toString().trim(),
            itemNo: selectGroceryItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectedCartProduct', JSON.stringify(cookieNewGroceryItemValue))
      var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
      var cookieNewCommonItemValue = []
      j = 0
      for (var i = 0; i < selectCommonItemCart.length; i++) {
        if (storeId != selectCommonItemCart[i].storeId) {
          cookieNewCommonItemValue[j] =
          {
            storeId: selectCommonItemCart[i].storeId.toString().trim(),
            itemId: selectCommonItemCart[i].itemId.toString().trim(),
            itemName: selectCommonItemCart[i].itemName.toString().trim(),
            quantity: selectCommonItemCart[i].quantity.toString().trim(),
            itemTitle: selectCommonItemCart[i].itemTitle.toString().trim(),
            brand: selectCommonItemCart[i].brand.toString().trim(),
            sizeName: selectCommonItemCart[i].sizeName.toString().trim(),
            sizeId: selectCommonItemCart[i].sizeId.toString().trim(),
            cmItemSizeId: selectCommonItemCart[i].cmItemSizeId.toString().trim(),
            itemMasterId: selectCommonItemCart[i].itemMasterId.toString().trim(),
            netAmount: selectCommonItemCart[i].netAmount.toString().trim(),
            mrp: selectCommonItemCart[i].mrp.toString().trim(),
            itemImage: selectCommonItemCart[i].itemImage.toString().trim(),
            itemNo: selectCommonItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectCommonItemCart', JSON.stringify(cookieNewCommonItemValue))
      var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
      var cookieNewRestaurantValue = []
      j = 0
      for (var i = 0; i < selectRestaurantCart.length; i++) {
        if (storeId !== selectRestaurantCart[i].storeId.toString()) {
          cookieNewRestaurantValue[j] =
          {
            storeId: selectRestaurantCart[i].storeId.toString().trim(),
            itemId: selectRestaurantCart[i].itemId.toString().trim(),
            itemName: selectRestaurantCart[i].itemName.toString().trim(),
            quantity: selectRestaurantCart[i].quantity.toString().trim(),
            itemSize: selectRestaurantCart[i].itemSize.toString().trim(),
            itemMrp: selectRestaurantCart[i].itemMrp.toString().trim(),
            itemImage: selectRestaurantCart[i].itemImage.toString().trim(),
            storeItemSizeId: selectRestaurantCart[i].storeItemSizeId.toString().trim(),
            itemNo: selectRestaurantCart[i].itemNo.toString().trim(),
            toppingsData: selectRestaurantCart[i].toppingsData.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectRestaurantCart', JSON.stringify(cookieNewRestaurantValue))
    }
  }
  fetchCityDetails() {
    let sellerId = window.sessionStorage.getItem('sellerId');
    var key = ""
    const postData = {
      "functionName": "homepagedata/getCityDetails",
      "sellerId": sellerId,
      "cityKeyWord": key
    }
    getData(postData).then((data) => {
      if (data.data.success === "1") {
        let suggestions = [];
        if ($("#txtCity").val() !== "" && localStorage.getItem('cityText')) {
          const regex = new RegExp(`^${localStorage.getItem('cityText').replace('\\(', "\\\\(").replace('\\)', "\\\\)")}`, `i`);
          suggestions = data.data.result.cityDetails.sort().filter(v => regex.test(v.cityName))
          this.setState({
            cityDetails: data.data.result.cityDetails,
            suggestions: suggestions,
          });
        }
        else {
          this.setState({
            cityDetails: data.data.result.cityDetails,
            suggestions: data.data.result.cityDetails,
          });
        }
      }
    });
  }
  fetchLocationDetails() {
    var key = ""
    let sellerId = window.sessionStorage.getItem('sellerId');
    let cityId = $("#hidCityId").val();
    const postData = {
      "functionName": "homepagedata/getLocationDetails",
      "sellerId": sellerId,
      "cityId": cityId,
      "locationKeyWord": key
    }
    getData(postData).then((data) => {
      console.log("data4", data)
      if (data.data.success === "1") {
        if (data.data.result.locationDetails.length === 1) {
          this.setState({
            locationDetails: data.data.result.locationDetails
          });
          this.suggestionLocationSelected(data.data.result.locationDetails[0].locationName, data.data.result.locationDetails[0].locationId)
        } else {
          $("#locationMainDiv").show()
          let suggestionsLoc = [];
          if ($("#txtLocation").val() !== "" && localStorage.getItem('locationText')) {
            const regex = new RegExp(`^${localStorage.getItem('locationText').replace('\\(', "\\\\(").replace('\\)', "\\\\)")}`, `i`);
            suggestionsLoc = data.data.result.locationDetails.sort().filter(v => regex.test(v.locationName))
            this.setState({
              locationDetails: data.data.result.locationDetails,
              suggestionsLoc: suggestionsLoc,
            });
          }
          else {
            this.setState({
              locationDetails: data.data.result.locationDetails,
              suggestionsLoc: data.data.result.locationDetails,
            });
          }
        }
      }
      $(".locationClear").show();
    });
  }
  handleCityClick() {
    if ($("#txtCity").val() === "") {
      this.fetchCityDetails()
    }
    else if (localStorage.getItem('cityText')) {
      this.fetchCityDetails()
    }
  }
  handleLocationClick() {

    if ($("#txtLocation").val() === "") {
      this.fetchLocationDetails()
    }
    else if (localStorage.getItem('locationText')) {
      this.fetchLocationDetails()
    }
  }
  onLocationTextChanged = (e) => {
    const value = e.target.value;
    let suggestionsLoc = [];
    if (value.length > 0) {
      const regex = new RegExp(`^${value.replace('(', "\\(").replace(')', "\\)")}`, `i`);
      suggestionsLoc = this.state.locationDetails.sort().filter(v => regex.test(v.locationName))
    }
    else {
      this.handleLocationClick()
    }
    this.setState(() => ({
      suggestionsLoc,
      textLocation: value,
    }));

  }
  suggestionLocationSelected(value, locationId) {
    this.setState({
      textLocation: value,
      locationId: locationId,
      suggestionsLoc: []
    }, () => {
      this.checkStoreInLocation()
    });
  }
  locationSelected() {
  }
  renderLocationSuggestions() {
    const { suggestionsLoc } = this.state;
    if (suggestionsLoc.length === 0) {
      return null;
    }
    return (
      <ul className="autoSearch">
        {suggestionsLoc.map((loc) => <li onClick={() => this.suggestionLocationSelected(loc.locationName, loc.locationId)}>{loc.locationName}</li>)}
      </ul>
    )
  }
  onCityTextChanged = (e) => {
    const value = e.target.value;
    let suggestions = [];
    if (value.length > 0) {
      const regex = new RegExp(`^${value.replace('\(', "\\(").replace('\)', "\\)")}`, `i`);
      suggestions = this.state.cityDetails.sort().filter(v => regex.test(v.cityName))
    }
    else {
      this.handleCityClick()
    }
    this.setState(() => ({
      suggestions,
      textCity: value,
    }));
  }
  suggestionCitySelected(value, cityId) {
    this.setState(() => ({
      textCity: value,
      cityId: cityId,
      suggestions: [],
      textLocation: "",
      locationId: ""
    }));
  }
  renderCitySuggestions() {
    const { suggestions } = this.state;
    if (suggestions.length === 0) {
      return null;
    }
    return (
      <div id="cityDiv">
        {this.state.suggestions.length >= 1 ?
          <ul className="autoSearch">
            {suggestions.map((city) => <li onClick={() => this.suggestionCitySelected(city.cityName, city.cityId)}>{city.cityName}</li>)}
          </ul>
          : ""}
      </div>
    )
  }
  goClick() {

    let siteCategoryGroupId = window.sessionStorage.getItem('siteCategoryId')
    let sellerId = window.sessionStorage.getItem('sellerId')
    if ($("#txtCity").val() === "") {
      alert("city required")
      $("#txtCity").focus()
      return false;
    }
    else if ($("#txtLocation").val() === "") {
      alert("location required")
      $("#txtLocation").focus()
      return false;
    }
    else if ($("#txtLocation").val() !== "") {
      var themeId = localStorage.getItem('themeId');
      var mainCategoryId = window.sessionStorage.getItem('mainCategoryId');
      var locationData = this.state.locationDetails.map((loc) => loc.locationName)
      if (locationData != "") {
        var location = $("#txtLocation").val();
        if (!locationData.includes(location)) {
          alert("invalid location")
          $("#txtLocation").focus()
          return false;
        }
        else {
          localStorage.setItem('cityId', $("#hidCityId").val());
          localStorage.setItem('locationId', $("#hidLocationId").val());
          localStorage.setItem('cityText', $("#txtCity").val());
          localStorage.setItem('locationText', $("#txtLocation").val());
          if (siteCategoryGroupId !== '0' && siteCategoryGroupId !== 'null' && siteCategoryGroupId !== null) {
            if (themeId === '36') {
              window.location.href = "/themeLocationhome";
            }
            else {
              window.location.href = "/home";
            }
          }
          else if (sellerId !== '0' && sellerId !== 'null' && sellerId !== null) {
            let locationId = localStorage.getItem('locationId');
            let sellerId = window.sessionStorage.getItem('sellerId');
            const postData = {
              functionName: "lokal/storesBySellerId",
              myCategoryId: '',
              locationId: locationId,
              categoryId: '',
              storeId: '',
              sellerId: sellerId
            }
            getData(postData).then((data) => {
              if (data.data.success === "1") {
                console.log("data555", data)
                window.sessionStorage.setItem('bookATable', data.data.result.storeData[0].hasReservationOption);
                window.sessionStorage.setItem('storeId', data.data.result.storeData[0].storeId);
                localStorage.setItem('cityId', data.data.result.storeData[0].cityId);
                localStorage.setItem('cityText', data.data.result.storeData[0].cityName);
                window.sessionStorage.setItem('mainCategoryId', data.data.result.storeData[0].mainCategoryId);
                window.sessionStorage.setItem('storeFullDetails', JSON.stringify(data.data.result));
                window.sessionStorage.setItem('storeCount', data.data.result.storeData.length);
                if (data.data.result.storeData[0].mainCategoryId === 1) {
                  if (themeId === '36') {
                    if (data.data.result.storeData.length > 1) {
                      window.location.href = "/themeLocationhome";
                    }
                    else {
                      window.location.href = "/themeHome";
                    }
                  }
                  else {
                    window.location.href = "/";
                  }
                }
                else if (data.data.result.storeData[0].mainCategoryId === 5) {
                  if (themeId === '37' || themeId === '32') {
                    window.location.href = "/";
                  }
                  else {
                    window.location.href = "/restaurantListing/0/0/";
                  }
                }
                else {
                  if (themeId === '36') {
                    window.location.href = "/themeLocationhome";
                  }
                  if (themeId === '38' || themeId === '28' || themeId === '2') {
                     window.location.href = "/";
                  }
                  else {
                    window.location.href = "/cmItemListing/0/0/0/";
                  }
                }
              }
            });
          }
        }
      }
      else {
        localStorage.setItem('cityId', $("#hidCityId").val());
        localStorage.setItem('locationId', $("#hidLocationId").val());
        localStorage.setItem('cityText', $("#txtCity").val());
        localStorage.setItem('locationText', $("#txtLocation").val());
        if (mainCategoryId === '1') {
          if (themeId === '36') {
            window.location.href = "/themeLocationhome";
          }
          else if(themeId === '1' || themeId === '2'){
            window.location.href = "/";
          }
          else {
            window.location.href = "/home";
          }
        }
        else if (mainCategoryId === '5') {
          if (themeId === '37') {
            window.location.href = "/";
          }
          else {
            window.location.href = "/restaurantListing/0/0/";
          }
        }
        else {
          if (themeId === '38' || themeId === '28' || themeId === '2') {
            window.location.href = "/";
          }
          else {
            window.location.href = "/cmHome";
          }
        }
      }
    }
    else {
      localStorage.setItem('cityId', $("#hidCityId").val());
      localStorage.setItem('locationId', $("#hidLocationId").val());
      localStorage.setItem('cityText', $("#txtCity").val());
      localStorage.setItem('locationText', $("#txtLocation").val());
      if (mainCategoryId === '1') {
        if (themeId === '36') {
          window.location.href = "/themeLocationhome";
        }
        else {
          window.location.href = "/home";
        }
      }
      else if (mainCategoryId === '5') {
        if (themeId === '37') {
          window.location.href = "/restaurantThemeHome";
        }
        else {
          window.location.href = "/restaurantListing/0/0/";
        }
      }
      else {
        if (themeId === '38' || themeId === '28') {
          window.location.href = "/";
        }
        else {
          window.location.href = "/cmHome";
        }
      }
    }
  }
  locationClose() {
    $("#txtLocation").val('');
    $(".locationClear").hide();
  }
  componentDidUpdate(prevProps, prevState) {
    const { textCity, textLocation } = this.state;
    const { cityId, locationId } = this.state;
  
    if (textCity === "" && cityId !== "") {
      this.setState({ cityId: "", textLocation: "", locationId: "" });
    }
  
    if (textLocation === "" && locationId !== "") {
      this.setState({ locationId: "" });
    }
  }
  render() {
    // const { textCity } = this.state;
    // const { cityId } = this.state;
    // const { textLocation } = this.state;
    // const { locationId } = this.state;
    // if (textCity == "") {
    //   this.state.cityId = "";
    //   this.state.textLocation = ""
    //   this.state.locationId = ""
    // }
    // if (textLocation == "") {
    //   this.state.locationId = "";
    // }
    return (
      <div>
        <div class="popOverlay"></div>
        <div class="loginPop" id="locationMainDiv" style={{ display: 'none' }}>
          <div class="loginHead">
            {localStorage.getItem('locationId') ?
              <span class="loginClose"><img src={close} alt="" /></span>
              : ''
            }

            <div className="loginText">Choose Delivery Location</div>
          </div>
          <div class="loginForm">
            <div class="loginFormList">
              <input type="hidden" value={this.state.cityId} id="hidCityId" />
              <input autoComplete="off" value={this.state.textCity} onChange={this.onCityTextChanged} onClick={this.handleCityClick} type="text" id="txtCity" class="inputField" placeholder="City" />
              {this.renderCitySuggestions()}
              <span className="locationFinder"><img src={locfinder} alt="" /></span>
            </div>
            <div class="loginFormList">
              <input type="hidden" value={this.state.locationId} id="hidLocationId" />
              <input autoComplete="off" value={this.state.textLocation} onChange={this.onLocationTextChanged} onClick={this.handleLocationClick} type="text" id="txtLocation" class="inputField" placeholder="Your Delivery Location" />
              {this.renderLocationSuggestions()}
              <span className="locationClear" onClick={this.locationClose}>x</span>
              <span onClick={this.checkStoreInLocation} className="goButton">Go</span>
            </div>
            <div className="topSearch">
              <div>
                <span>Top Searches</span>
                {this.state.topLocations.map((locationObj) => (
                  <p>{locationObj.locationName}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
